// extracted by mini-css-extract-plugin
export default {"button":"JobCellTemplate_button__dfifS","cell":"JobCellTemplate_cell__b8HEP"};